import { render, staticRenderFns } from "./SubmenuProfile.vue?vue&type=template&id=5b0b7684&scoped=true"
import script from "./SubmenuProfile.vue?vue&type=script&lang=ts"
export * from "./SubmenuProfile.vue?vue&type=script&lang=ts"
import style0 from "./SubmenuProfile.vue?vue&type=style&index=0&id=5b0b7684&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b7684",
  null
  
)

export default component.exports